import yaml from 'js-yaml';

export type ApprovalsConfigDoc = Record<string, unknown>;

export function parseApprovalsYaml(content: string): ApprovalsConfigDoc {
  const parsed = yaml.load(content);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error('Approvals YAML must be a mapping at the root');
  }
  return parsed as ApprovalsConfigDoc;
}

export function approvalsDocToYaml(doc: ApprovalsConfigDoc): string {
  return yaml.dump(doc, { lineWidth: 120, noRefs: true, skipInvalid: true });
}

export {
  cloneDoc,
  ensureObject,
  asString,
  asBool,
  asNumber,
  objectRecord,
} from './tenant-config-form-utils';
